module.exports = __webpack_public_path__ + "static/media/settings.0d434620.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/settings.svg
// module id = 157
// module chunks = 0